import {
	DEFAULT_MEDIA_QUERY_PLATFORMS as MQ,
	COMPONENT_STATES as STATE,
	COMPONENT_TYPE as TYPE,
	LAYER_TYPE,
	COMPONENT_DISPLAY_NAME,
} from 'common/constants';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import View from './AnswerInput';
import { defaultProps } from './constants';

export const ANSWER_INPUT = () => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.ANSWER_INPUT;

			return {
				_id,
				type,
				uiConfig: {
					layer: LAYER_TYPE.CONTENT,
					editorProps: {
						name: COMPONENT_DISPLAY_NAME[type],
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, type),
					},
					componentProps: {
						[UNIFORM_PROPS.fieldPlaceholder]: '',
						[UNIFORM_PROPS.answerInputMode]: defaultProps.answerInputMode,
						styles: {
							[STATE.DEFAULT]: {
								[MQ.DEFAULT]: {},
								[MQ.DESKTOP]: {},
								[MQ.TABLET]: {},
								[MQ.MOBILE]: {},
							},
							[STATE.HOVER]: {
								[MQ.DEFAULT]: {},
							},
							[STATE.CORRECT]: {
								[MQ.DEFAULT]: {},
							},
							[STATE.INCORRECT]: {
								[MQ.DEFAULT]: {},
							},
						},
						other: {},
					},
				},
				children: [],
			};
		},
	};
};
